import React from "react"
import { Link } from 'gatsby'

export default ({ show, toggleShow, full, exam, noAction, toDetails }) => {

  return (
    show ? <div className={`modal flexed fl-c` + (full && ' full')}>
      <div className={`p-45` + (full && ' bg-top-nav w-50 shadow-mild radius-8 popIn')}>
        <h3 className="m-0 text-shadow font-16 px-8">نتیجه آزمون</h3>
        <hr className="mb-0" />
        <div className="p-32 modal-content">

          <div className="time-wrapper ltr relative" style={{ top: 0, right: 0, background: 'var(--bg)', width: 164, height: 164, margin: 'auto' }}>
            <div className="pie spinner" style={{ transform: `rotate(${exam.percent / 100 * 360}deg)`, background: 'var(--footer)' }} />
            <div className="pie filler" style={{ opacity: exam.percent / 100 * 360 > 180 ? 1 : 0, background: 'var(--footer)' }} />
            <div className="mask" style={{ opacity: exam.percent / 100 * 360 > 180 ? 0 : 1 }} />
            <div className="time flexed fdir-col align-c text-footer"
              style={{ background: 'var(--top-nav)', width: 130, height: 130, top: 'calc(50% - 65px)', right: 'calc(50% - 65px)' }}>
              <span>امتیاز</span>
              <span className="bold font-16 pt-8">{`%${exam.percent?.toString().slice(0, 5)}`}</span>
            </div>
          </div>
          <div className="text-center mt-16">
            <span className="font-14">حد نصاب قبولی:</span>
            <span dir="ltr" className="font-20 pr-16">{`%${exam.exam?.pass_percent}`}</span>
          </div>

          <div>
            <h4 className="m-0 text-shadow px-8 mt-16">جزئیات</h4>
            <hr className="mb-0" />
            <div className="flexed px-16 pt-20">
              <div className="flex-1">
                <span className="font-8">تعداد سوالات: </span>
                <span className="font-10 bold">{exam.exam?.q_count} عدد</span>
              </div>
              <div className="flex-1">
                <span className="font-8">تعداد صحیح: </span>
                <span className="font-10 bold">{exam.q_true} عدد</span>
              </div>
              <div className="flex-1">
                <span className="font-8">تعداد غلط: </span>
                <span className="font-10 bold">{exam.q_false} عدد</span>
              </div>
              <div className="flex-1">
                <span className="font-8">تعداد بی پاسخ: </span>
                <span className="font-10 bold">{exam.exam?.q_count - exam.q_false - exam.q_true} عدد</span>
              </div>
            </div>
            <div className="flexed px-16 pt-16">
              <div className="flex-1">
                <span className="font-8">تاریخ آزمون: </span>
                <span className="font-10 bold">{exam.exam?.submit_date?.slice(0, 10)}</span>
              </div>
              <div className="flex-1">
                <span className="font-8">مدت زمان: </span>
                <span className="font-10 bold">{exam.exam?.time} دقیقه</span>
              </div>
              <div className="flex-1">
                <span className="font-8">زمان شروع: </span>
                <span className="font-10 bold">{exam.start_date?.slice(0, 10)}</span>
              </div>
              <div className="flex-1">
                <span className="font-8">زمان پایان: </span>
                <span className="font-10 bold">{exam.end_date?.slice(0, 10)}</span>
              </div>
            </div>
          </div>
        </div>
        {
          toDetails ? <div className="ltr mt-32 px-8">
            <Link to={`/exam/taken-exams/${exam.id}`}>
              <button className="bd-none iran-sans radius-4 font-10 text-top-nav bg-tomato"
                style={{ padding: '5px 0', width: 100 }}>
                جزئیات آزمون
              </button>
            </Link>

            <Link to={`/exam/list`}>
              <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
                onClick={() => toggleShow(false)}
                style={{ color: 'var(--tomato)', padding: '5px 0', width: 100, border: '1px solid var(--tomato)' }}>لیست آزمون ها</button>
            </Link>
          </div> :

            <div className="ltr mt-32 px-8">
              {!noAction && <a href={`/exam/taken-exams/${exam.id}`} target="_blank">
                <button className="bd-none iran-sans radius-4 font-10 text-top-nav bg-tomato"
                  style={{ padding: '5px 0', width: 100 }}>
                  جزئیات آزمون
                </button>
              </a>}

              <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
                onClick={() => toggleShow(false)}
                style={{ color: 'var(--tomato)', padding: '5px 0', width: 100, border: '1px solid var(--tomato)' }}>بستن</button>
            </div>
        }

      </div>
    </div> : <div></div>
  )
}
